import Color from "../external/color/index.js";
const alpha = (color, percent) => {
  if (percent >= 100)
    return color;
  const mixStr = `0.${`0${100 - percent}`.slice(-2)}`, mixNum = parseFloat(mixStr);
  return Color(color).mix(Color("white"), mixNum).hex();
};
export {
  alpha
};
//# sourceMappingURL=utils.js.map
